import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from "react-router-dom";
@inject('userStore')

@observer
class AdminSideMenu extends Component {


  render() {
    return (
      <div className={"adminsidebar"} style={{position: "relative"}}>
        {/* <button onClick={() => this.props.close()} style={{position: "absolute", top: 0, right: 0}} className={"adminMenuToggle"}>◄</button> */}
        <div onClick={() => this.props.history.push("/internal/admin")} style={{cursor: "pointer"}}>
          DASHBOARD
        </div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={ () => this.props.history.push("/internal/admin/map")} className={"menu-item"}> Übersichts Karte</div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={() => this.props.history.push("/internal/admin/residence")} className={"menu-item"}>Residence</div>
        <div onClick={ () => this.props.history.push("/internal/admin/members")}className={"menu-item"}>Mitglieder</div>
        <div onClick={ () => this.props.history.push("/internal/admin/companies")} className={"menu-item"}>Firmen</div>
        <div onClick={ () => this.props.history.push("/internal/admin/applications")} className={"menu-item"}>Bewerbungen</div>
        <div onClick={ () => this.props.history.push("/internal/admin/applicationwaitlist")} className={"menu-item"}>Bewerbungs-Warteliste</div>
        <div onClick={ () => this.props.history.push("/internal/admin/informationrequest")} className={"menu-item"}>Info-Anfragen</div>
        <div onClick={ () => this.props.history.push("/internal/admin/golfclubrequests")} className={"menu-item"}> Golf-Club Anfragen</div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={ () => this.props.history.push("/internal/admin/contracts")} className={"menu-item"}> Verträge</div>
        <div onClick={ () => this.props.history.push("/internal/admin/invoices")} className={"menu-item"}>Rechnungen</div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={ () => this.props.history.push("/internal/admin/analytics")} className={"menu-item"}>Statistiken</div>
        <div onClick={ () => this.props.history.push("/internal/admin/rules")} className={"menu-item"}>Regelwerk</div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={ () => this.props.history.push("/internal/admin/tournamentregistrations")} className={"menu-item"}>Turnier Anmeldungen</div>
        <div style={{borderBottom: '1px solid #DAB777', width: '50%', marginTop: 25, marginBottom: 25}}></div>
        <div onClick={ () => this.props.history.push("/backend/admin")} className={"menu-item"}> CMS </div>
      </div>
    );
  }
}

export default withRouter(AdminSideMenu);



// WEBPACK FOOTER //
// /src/components/admin/AdminSideMenu.js